import React, { Component } from 'react';
import './index.scss';

import Message from '@/component/message';

import userService from '@/service/user';
import agreementService from '@/service/agreement';
import localStoragePerfect from '@/util/localstorage-perfect';

const state = {
    isLogin: false
};

class Header extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = state;
    }

    public render() {
        return (
            <div className="chj-header">
                <div className="chj-header-inner">
                    <div className="chj-header-left" onClick={this.goIndex}>
                        <span className="chj-header-logo">
                            <img
                                // eslint-disable-next-line global-require
                                src={require('../../image/logo/logo-text-white.svg')}
                            />
                        </span>
                        <span className="chj-header-divide" />
                        <span className="chj-header-text">
                            维修信息公开系统
                        </span>
                    </div>
                    {!this.props.isAgreement && (
                        <div className="chj-header-right">
                            {this.state.isLogin ? (
                                <div className="chj-header-profile">
                                    <i className="iconfont iconfont-profile" />
                                    <div className="chj-header-profile-pop">
                                        <ul>
                                            <li onClick={this.goPayList}>
                                                支付记录
                                            </li>
                                            <li onClick={this.logout}>
                                                退出登录
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className="chj-header-login"
                                    onClick={this.goLogin}>
                                    注册/登录
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    public componentDidMount() {
        if (localStoragePerfect.getItem('isLogin') === 'true') {
            this.setState({
                isLogin: true
            });
        }
        this.getTokenStatus();
    }

    private getAgreeStatus = async () => {
        const response = await agreementService.getAgreeStatus();

        if (
            (!response || !response.data.isReadAgreements) &&
            !this.props.isAgreement
        ) {
            this.goGreement();
        }
    };

    private getTokenStatus = async () => {
        const response = await userService.checkLogin();
        const isLogin = response.success;

        this.setState({
            isLogin
        });

        localStoragePerfect.setItem('isLogin', isLogin.toString());
        if (response.code === 240226) {
            Message.error('您的账号已在别处登录');
        }
        if (!isLogin) {
            this.goLogin();
        } else {
            this.getAgreeStatus();
        }
    };

    private logout = async () => {
        await userService.logout();
        localStoragePerfect.setItem('isLogin', 'false');
        this.goLogin();
    };

    private goIndex = () => {
        if (!this.props.isAgreement) {
            location.href = '/autoinfo/index.html';
        }
    };

    private goLogin = () => {
        location.href = `/login.html?originalUrl=${encodeURIComponent(
            `${window.location.origin}/autoinfo/index.html`
        )}`;
    };

    private goPayList = () => {
        location.href = '/autoinfo/order.html';
    };

    private goGreement = () => {
        location.href = `/autoinfo/agreement.html?originalUrl=${encodeURIComponent(
            location.href
        )}`;
    };
}

export default Header;
